import _asyncToGenerator from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
// eslint-disable-next-line no-unused-vars
import React, { useState, useEffect } from 'react';
export var useYextFetch = function useYextFetch(mainYextId, isFolder, limit) {
  var _useState = useState('no data'),
    yextContactInformationData = _useState[0],
    setYextContactInformationData = _useState[1];
  var isMultiple = mainYextId.length > 1; // TODO: double check

  var yextLiveApi = [];
  if (isMultiple) {
    //NVAMSP-292: Yext Live API has a limit of 50 to filter per query. If the array is over 50 IDs, split it into batches of 50
    if (mainYextId.length > 50) {
      var idsArray = [];
      var startIndex = 0;
      for (var i in mainYextId) {
        if (i % 50 == 0 && i != 0) {
          var subArray = mainYextId.slice(startIndex, i);
          idsArray.push(subArray);
          startIndex = i;
        }
        if (i == mainYextId.length - 1) {
          var _subArray = mainYextId.slice(startIndex);
          idsArray.push(_subArray);
        }
      }
      for (var array in idsArray) {
        yextLiveApi.push("https://liveapi.yext.com/v2/accounts/me/entities?filter=%7B%22meta.id%22%3A%7B%22%24in%22%3A".concat(JSON.stringify(idsArray[array]), "%7D%7D&limit=").concat(limit || 50, "&api_key=").concat(process.env.NEXT_PUBLIC_YEXT_API_KEY, "&v=20161012"));
      }
    } else {
      var mapIds = [];
      mainYextId.map(function (id, i) {
        mapIds.push("".concat(id.trim()));
      });
      yextLiveApi.push("https://liveapi.yext.com/v2/accounts/me/entities?filter=%7B%22meta.id%22%3A%7B%22%24in%22%3A".concat(JSON.stringify(mapIds), "%7D%7D&limit=").concat(limit || 50, "&api_key=").concat(process.env.NEXT_PUBLIC_YEXT_API_KEY, "&v=20161012"));
    }
    // get yext entities by mathing multiple Id's
  } else if (mainYextId && isFolder) {
    var folderIds = mainYextId.map(function (id) {
      var idAsNum = parseInt(id);
      return idAsNum;
    });
    // get entities by folder
    yextLiveApi.push("https://liveapi.yext.com/v2/accounts/me/entities?filter=%7B%20%22meta.folderId%22%3A%7B%22%24in%22%3A[".concat(folderIds, "]%7D%7D&limit=").concat(limit || 50, "&api_key=").concat(process.env.NEXT_PUBLIC_YEXT_API_KEY, "&v=20161012"));
  } else {
    // get a single entity
    yextLiveApi.push("https://liveapi.yext.com/v2/accounts/me/entities/".concat(mainYextId, "?api_key=").concat(process.env.NEXT_PUBLIC_YEXT_API_KEY, "&v=20161012"));
  }
  var getData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(yextLiveApi) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", Promise.all(yextLiveApi.map( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(each) {
                  var resultData, response, otherPageresult;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return fetch(each, {
                            credentials: 'omit'
                            // eslint-disable-next-line no-console
                          })["catch"](function (err) {
                            return console.log("".concat(err));
                          });
                        case 2:
                          resultData = _context.sent;
                          _context.next = 5;
                          return resultData.json()
                          // eslint-disable-next-line no-console
                          ["catch"](function (err) {
                            return console.log("".concat(err));
                          });
                        case 5:
                          response = _context.sent;
                          if (!(response.response && response.response.count && response.response.count > 50 && response.response.pageToken)) {
                            _context.next = 11;
                            break;
                          }
                          _context.next = 9;
                          return getData(["".concat(yextLiveApi, "&pageToken=").concat(response.response.pageToken)]);
                        case 9:
                          otherPageresult = _context.sent;
                          if (otherPageresult && otherPageresult.length > 0 && otherPageresult[0].entities) {
                            otherPageresult[0].entities.map(function (each) {
                              response.response.entities.push(each);
                            });
                          }
                        case 11:
                          return _context.abrupt("return", response.response);
                        case 12:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }())
              // eslint-disable-next-line no-console
              )["catch"](function (err) {
                return console.log("".concat(err));
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function getData(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var parseData = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(yextLiveApi) {
      var data, singleData, entities;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return getData(yextLiveApi);
            case 2:
              data = _context3.sent;
              if (!(data && data.length > 0)) {
                _context3.next = 15;
                break;
              }
              if (!(data.length == 1)) {
                _context3.next = 10;
                break;
              }
              singleData = data[0];
              if (singleData.entities) {
                singleData.entities = singleData.entities.sort(function (a, b) {
                  return a.meta.id > b.meta.id ? 1 : -1;
                });
              }
              return _context3.abrupt("return", singleData);
            case 10:
              if (!(data.length > 1)) {
                _context3.next = 15;
                break;
              }
              entities = [];
              data.map(function (each) {
                each.entities && each.entities.map(function (eachEntity) {
                  entities.push(eachEntity);
                });
              });
              entities = entities.sort(function (a, b) {
                return a.meta.id > b.meta.id ? 1 : -1;
              });
              return _context3.abrupt("return", {
                entities: entities
              });
            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function parseData(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  useEffect(function () {
    parseData(yextLiveApi).then(function (data) {
      setYextContactInformationData(data);
    });
  }, []);
  return yextContactInformationData;
};